import request from '@/utils/request'

/**
 * 获取任务列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listTasks(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/task.listTasks',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取模板列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listTaskTemplate(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/task.listTaskTemplate',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取模板规格
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listTaskTemplateSpec(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/task.listTaskTemplateSpec',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加任务
 * @param {Object} data 任务数据
 * @returns {Promise} Promise对象
 */
export function saveTask(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/task.saveTask',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 修改任务
 * @param {Object} data 任务数据
 * @returns {Promise} Promise对象
 */
export function updateTask(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/task.updateTask',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除任务
 * @param {Object} data 任务数据
 * @returns {Promise} Promise对象
 */
export function deleteTask(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/task.deleteTask',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 启动任务
 * @param {Object} data 任务数据
 * @returns {Promise} Promise对象
 */
export function startTask(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/task.startTask',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 停止任务
 * @param {Object} data 任务数据
 * @returns {Promise} Promise对象
 */
export function stopTask(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/task.stopTask',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}